import { render, staticRenderFns } from "./GalleryAndText.vue?vue&type=template&id=6833f768&scoped=true&"
import script from "./GalleryAndText.vue?vue&type=script&lang=js&"
export * from "./GalleryAndText.vue?vue&type=script&lang=js&"
import style0 from "./GalleryAndText.vue?vue&type=style&index=0&id=6833f768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833f768",
  null
  
)

export default component.exports